import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

import { ICustomNotification, NotificationType } from '@app/settings/models';
import { Endpoint } from '@app/constants/endpoints.constants';

@Injectable({
  providedIn: 'root'
})
export class CustomNotificationsRepoService {
  constructor(private _httpClient: HttpClient) {}

  getCustomNotifications(selectedMonth: { year: string; month: string }): Observable<ICustomNotification> {
    return this._httpClient.get<ICustomNotification>(Endpoint.CustomNotifications, { params: { ...selectedMonth } });
  }

  postCustomNotifications(
    year: string,
    month: string,
    notifications: ICustomNotification,
    setDefault: boolean,
    types: NotificationType[]
  ): Observable<undefined> {
    let params = new HttpParams()
      .set('year', year)
      .set('month', month)
      .set('set-default-notifications', setDefault.toString());

    if (types.length === 1) {
      params = params.set('type', types[0]);
    }

    return this._httpClient.post<undefined>(Endpoint.CustomNotifications, { ...notifications }, { params });
  }

  restoreNotification(selectedMonth: {
    year: string;
    month: string;
    type: NotificationType;
  }): Observable<ICustomNotification> {
    return this._httpClient.get<ICustomNotification>(Endpoint.CustomNotifications + Endpoint.RestoreNotifications, {
      params: { ...selectedMonth }
    });
  }
}
